<template>
  <div>
    <login-account v-if="tab==='account'" @success="onSuccessed"></login-account>
    <login-phone v-else @success="onSuccessed"></login-phone>
    <div>
      <span class="switch-link" :style="`color:${theme.themeColor}`" @click="changeTab()">
        {{ tab === 'account' ? '手机号登录' : '账号登录'}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginAccount from './LoginAccount'
import LoginPhone from './LoginPhone'

export default {
  components: {
    LoginAccount,
    LoginPhone
  },
  data() {
    return {
      tab: 'account'
    }
  },
  computed: {
    ...mapState(['theme'])
  },
  methods: {
    changeTab() {
      this.tab = this.tab === 'account' ? 'phone' : 'account'
    },
    onSuccessed(data) {
      this.$emit('success', data)
    }
  }
}

</script>

<style lang="scss" scoped>
.switch-link {
  cursor: pointer;
  display: inline-block;
  color: $themeColor;
  font-size: 14px;
  margin-top: 20px;
}
</style>
